import React from "react";
import CardMetric from "../DesignSystem/Cards/CardMetric";

/**
 * Renders the financial performance details section, including a title, optional description,
 * and a set of financial performance indicators.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.title - The main title to display.
 * @param {string} [props.description=""] - An optional description or subtitle.
 * @param {string} [props.link="/"] - An optional link (currently unused).
 * @returns {JSX.Element} The rendered FinancialPerformanceDetails component.
 */
const FinancialPerformanceDetails = ({
  title,
  description = "",
  link = "/",
}) => {
  // const navigate = useNavigate();
  return (
    <div className="Financial-Performance">
      <h2>{title}</h2>
      {description && <div className="SubTitle">{description}</div>}

      <div className="Financial-Performance-Indicator">
        <CardMetric content="Access to:" value="80+ lenders" />
        <CardMetric content="Protection Proposition:" value="Whole of market" />
        <CardMetric content="Platform charges:" value="Highly Competitive" />
      </div>
    </div>
  );
};

export default FinancialPerformanceDetails;
